"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var BemBuilder_1 = __importDefault(require("Utils/BemBuilder"));
var mobx_1 = require("mobx");
var Types_1 = require("@CommonFrontendBackend/QuoteV2/Types");
var inversify_react_1 = require("inversify-react");
var mobx_react_1 = require("mobx-react");
var Types_2 = require("@CommonFrontendBackend/Tokens/Types");
var NumberInput_1 = __importDefault(require("NumberInput/NumberInput"));
var FetchUtils_1 = require("@CommonFrontendBackend/Utils/FetchUtils");
var QuoteProductStore_1 = require("../QuoteProductStore/QuoteProductStore");
var Types_3 = require("ContentTokens/Models/inputs/Types");
var ProductMetadataService_1 = require("@CommonFrontendBackend/Tokens/ProductMetadataService");
var lodash_1 = require("lodash");
var QuoteTelemetry_1 = require("Telemetry/QuoteTelemetry");
var friendlyFilters_1 = require("QuoteV2/Components/friendlyFilters");
var c = (0, BemBuilder_1.default)("quote-product-filter");
var QuoteProductFilter = (function (_super) {
    __extends(QuoteProductFilter, _super);
    function QuoteProductFilter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    QuoteProductFilter.prototype.startTrackingChanges = function () {
        this.lastFilterSettings = (0, lodash_1.cloneDeep)(this.props.item.filter);
    };
    QuoteProductFilter.prototype.finishTrackingChanges = function () {
        var filter = this.props.item.filter;
        if (!(0, lodash_1.isEqual)(filter, this.lastFilterSettings)) {
            this.quoteTelemetry.trackProductLineItemFilterConfigured(filter === null || filter === void 0 ? void 0 : filter.token.name, filter === null || filter === void 0 ? void 0 : filter.operation.toString());
        }
        this.lastFilterSettings = undefined;
    };
    QuoteProductFilter.prototype.selectToken = function (token) {
        var _a, _b, _c, _d;
        var item = this.props.item;
        if (!token) {
            item.filter = undefined;
        }
        else if (ProductMetadataService_1.ProductMetadataService.canFormat((_a = token.substitutionToken) === null || _a === void 0 ? void 0 : _a.id)) {
            var options = ProductMetadataService_1.ProductMetadataService.getEnumeration((_b = token.substitutionToken) === null || _b === void 0 ? void 0 : _b.id);
            item.filter = {
                type: Types_1.ProductFilterType.Enum,
                token: token,
                operation: Types_1.ProductFilterEnumOperation.Equals,
                value: options[0].id,
            };
        }
        else if (((_c = token.substitutionToken) === null || _c === void 0 ? void 0 : _c.dataType) === Types_2.TokenDataType.String) {
            item.filter = {
                type: Types_1.ProductFilterType.String,
                token: token,
                operation: Types_1.ProductFilterStringOperation.Equals,
                value: "",
            };
        }
        else if (((_d = token.substitutionToken) === null || _d === void 0 ? void 0 : _d.dataType) === Types_2.TokenDataType.Number) {
            item.filter = {
                type: Types_1.ProductFilterType.Number,
                token: token,
                operation: Types_1.ProductFilterNumberOperation.Equals,
                value: 0,
            };
        }
    };
    QuoteProductFilter.prototype.renderPanelContents = function () {
        var _this = this;
        var _a, _b, _c, _d, _e, _f, _g;
        var item = this.props.item;
        var productToken = item.token;
        var tokenData = this.quoteProductStore.productTokenItemProperties;
        if (tokenData.status === FetchUtils_1.RemoteDataStatus.NotRequested || tokenData.status === FetchUtils_1.RemoteDataStatus.Loading) {
            return react_1.default.createElement(kaleidoscope_1.Spinner, null);
        }
        if (tokenData.status === FetchUtils_1.RemoteDataStatus.Error) {
            return "Unable to retrieve product tokens to filter on; please refresh the page and try again";
        }
        return (react_1.default.createElement("div", { className: c("panel-contents") },
            react_1.default.createElement("span", { className: c("label") }, "Display products if"),
            react_1.default.createElement(kaleidoscope_1.Dropdown, { theme: kaleidoscope_2.DropdownTheme.Dark, name: ((_a = item.filter) === null || _a === void 0 ? void 0 : _a.token.name) ? (0, friendlyFilters_1.removeChildPropertyLabel)(productToken, item.filter.token.label) : "Display all" },
                react_1.default.createElement(kaleidoscope_2.DropdownItem, { name: "Display all", selected: !item.filter, onSelect: function () {
                        _this.selectToken();
                    } }),
                tokenData.data.map(function (token) {
                    var _a;
                    return (react_1.default.createElement(kaleidoscope_2.DropdownItem, { key: token.label, name: (0, friendlyFilters_1.removeChildPropertyLabel)(productToken, token.label), selected: ((_a = item.filter) === null || _a === void 0 ? void 0 : _a.token.label) === token.label, onSelect: function () {
                            _this.selectToken(token);
                        } }));
                })),
            ((_b = item.filter) === null || _b === void 0 ? void 0 : _b.type) === Types_1.ProductFilterType.String && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Dropdown, { theme: kaleidoscope_2.DropdownTheme.Dark, name: (0, friendlyFilters_1.labelForStringOperation)(item.filter.operation) }, Object.values(Types_1.ProductFilterStringOperation).map(function (operation) { return (react_1.default.createElement(kaleidoscope_2.DropdownItem, { key: operation, name: (0, friendlyFilters_1.labelForStringOperation)(operation), selected: item.filter.operation === operation, onSelect: function () {
                        (0, mobx_1.runInAction)(function () {
                            item.filter.operation = operation;
                        });
                    } })); })),
                react_1.default.createElement(kaleidoscope_1.TextInput, { label: "value", labelHidden: true, theme: kaleidoscope_1.TextInputTheme.Dark, size: kaleidoscope_1.TextInputSize.Small, value: item.filter.value, placeholder: "Type something", onChange: function (newValue) {
                        (0, mobx_1.runInAction)(function () {
                            item.filter.value = newValue;
                        });
                    } }))),
            ((_c = item.filter) === null || _c === void 0 ? void 0 : _c.type) === Types_1.ProductFilterType.Number && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Dropdown, { theme: kaleidoscope_2.DropdownTheme.Dark, name: (0, friendlyFilters_1.labelForNumberOperation)(item.filter.operation) }, Object.values(Types_1.ProductFilterNumberOperation).map(function (operation) { return (react_1.default.createElement(kaleidoscope_2.DropdownItem, { key: operation, name: (0, friendlyFilters_1.labelForNumberOperation)(operation), selected: item.filter.operation === operation, onSelect: function () {
                        (0, mobx_1.runInAction)(function () {
                            item.filter.operation = operation;
                        });
                    } })); })),
                react_1.default.createElement(NumberInput_1.default, { label: "value", labelHidden: true, theme: kaleidoscope_1.TextInputTheme.Dark, size: kaleidoscope_1.TextInputSize.Small, value: item.filter.value, onChange: function (newValue) {
                        (0, mobx_1.runInAction)(function () {
                            item.filter.value = newValue;
                        });
                    } }))),
            ((_d = item.filter) === null || _d === void 0 ? void 0 : _d.type) === Types_1.ProductFilterType.Enum && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(kaleidoscope_1.Dropdown, { theme: kaleidoscope_2.DropdownTheme.Dark, name: (0, friendlyFilters_1.labelForEnumOperation)(item.filter.operation) }, Object.values(Types_1.ProductFilterEnumOperation).map(function (operation) { return (react_1.default.createElement(kaleidoscope_2.DropdownItem, { key: operation, name: (0, friendlyFilters_1.labelForEnumOperation)(operation), selected: item.filter.operation === operation, onSelect: function () {
                        (0, mobx_1.runInAction)(function () {
                            item.filter.operation = operation;
                        });
                    } })); })),
                react_1.default.createElement(kaleidoscope_1.Dropdown, { theme: kaleidoscope_2.DropdownTheme.Dark, name: ProductMetadataService_1.ProductMetadataService.format((_e = item.filter.token.substitutionToken) === null || _e === void 0 ? void 0 : _e.id, item.filter.value) }, ProductMetadataService_1.ProductMetadataService.getEnumeration((_g = (_f = item.filter) === null || _f === void 0 ? void 0 : _f.token.substitutionToken) === null || _g === void 0 ? void 0 : _g.id).map(function (option) { return (react_1.default.createElement(kaleidoscope_2.DropdownItem, { key: option.id, name: option.name, selected: item.filter.value === option.id, onSelect: function () {
                        (0, mobx_1.runInAction)(function () {
                            item.filter.value = option.id;
                        });
                    } })); }))))));
    };
    QuoteProductFilter.prototype.render = function () {
        var _this = this;
        var _a = this.props, children = _a.children, alignment = _a.alignment;
        return (react_1.default.createElement(kaleidoscope_1.Popover, { autoStack: true, className: c("popover"), size: kaleidoscope_1.PopoverSize.Small, theme: kaleidoscope_1.PopoverTheme.Dark, onChange: function (isOpen) {
                if (isOpen) {
                    _this.startTrackingChanges();
                }
                else {
                    _this.finishTrackingChanges();
                }
            }, button: function (_a) {
                var ref = _a.ref, buttonProps = __rest(_a, ["ref"]);
                return (react_1.default.createElement(kaleidoscope_1.Button, __assign({ type: kaleidoscope_1.ButtonType.Tertiary, size: kaleidoscope_1.ButtonSize.XSmall, decorator: kaleidoscope_1.ButtonDecorator.Dropdown, "aria-label": "Edit product filter", ref: ref }, buttonProps, { className: c("popover-button") }), children));
            }, alignment: alignment }, this.renderPanelContents()));
    };
    var _a, _b, _c;
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_a = typeof QuoteProductStore_1.QuoteProductStore !== "undefined" && QuoteProductStore_1.QuoteProductStore) === "function" ? _a : Object)
    ], QuoteProductFilter.prototype, "quoteProductStore", void 0);
    __decorate([
        inversify_react_1.resolve,
        __metadata("design:type", typeof (_b = typeof QuoteTelemetry_1.QuoteTelemetry !== "undefined" && QuoteTelemetry_1.QuoteTelemetry) === "function" ? _b : Object)
    ], QuoteProductFilter.prototype, "quoteTelemetry", void 0);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [typeof (_c = typeof Types_3.TokenInput !== "undefined" && Types_3.TokenInput) === "function" ? _c : Object]),
        __metadata("design:returntype", void 0)
    ], QuoteProductFilter.prototype, "selectToken", null);
    QuoteProductFilter = __decorate([
        mobx_react_1.observer
    ], QuoteProductFilter);
    return QuoteProductFilter;
}(react_1.default.Component));
exports.default = QuoteProductFilter;
